module.exports = __webpack_public_path__ + "img/121.9.8fa9767b.png";